/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_ISSUES_REQUEST,
  GET_ISSUES_SUCCESS,
  GET_ISSUES_FAILURE,
  CREATE_ISSUE_REQUEST,
  CREATE_ISSUE_SUCCESS,
  CREATE_ISSUE_FAILURE,
  SUPPORT_HOMEPAGE_REQUEST,
  SUPPORT_HOMEPAGE_SUCCESS,
  SUPPORT_HOMEPAGE_FAILURE,
  GET_REQUESTTYPES_REQUEST,
  GET_REQUESTTYPES_SUCCESS,
  GET_REQUESTTYPES_FAILURE,
  GET_ISSUESTATUS_REQUEST,
  GET_ISSUESTATUS_SUCCESS,
  GET_ISSUESTATUS_FAILURE,
  GET_ISSUECOMMENTS_REQUEST,
  GET_ISSUECOMMENTS_SUCCESS,
  GET_ISSUECOMMENTS_FAILURE,
  ADD_ISSUECOMMENTS_REQUEST,
  ADD_ISSUECOMMENTS_SUCCESS,
  ADD_ISSUECOMMENTS_FAILURE,
  REOPENISSUE_REQUEST,
  REOPENISSUE_SUCCESS,
  REOPENISSUE_FAILURE,
  ADD_ATTACHMENTS_REQUEST,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_ATTACHMENTS_FAILURE,
  GET_REPORTED_TICKETS_REQUEST,
  GET_REPORTED_TICKETS_SUCCESS,
  GET_REPORTED_TICKETS_FAILURE,
  CREATE_REPORT_TICKET_REQUEST,
  CREATE_REPORT_TICKET_SUCCESS,
  CREATE_REPORT_TICKET_FAILURE,
  TICKET_HOMEPAGE_REQUEST,
  TICKET_HOMEPAGE_SUCCESS,
  TICKET_HOMEPAGE_FAILURE,
  GET_TICKET_STATUS_REQUEST,
  GET_TICKET_STATUS_SUCCESS,
  GET_TICKET_STATUS_FAILURE,
  GET_TICKET_COMMENTS_REQUEST,
  GET_TICKET_COMMENTS_SUCCESS,
  GET_TICKET_COMMENTS_FAILURE,
  ADD_TICKET_COMMENTS_REQUEST,
  ADD_TICKET_COMMENTS_SUCCESS,
  ADD_TICKET_COMMENTS_FAILURE,
  RE_OPEN_TICKET_REQUEST,
  RE_OPEN_TICKET_SUCCESS,
  RE_OPEN_TICKET_FAILURE,
  GET_COMPLETED_TICKETS_REQUEST,
  GET_COMPLETED_TICKETS_SUCCESS,
  GET_COMPLETED_TICKETS_FAILURE,
  GET_TICKETS_COUNTS_REQUEST,
  GET_TICKETS_COUNTS_SUCCESS,
  GET_TICKETS_COUNTS_FAILURE,
  GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST,
  GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS,
  GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE,
  GET_TICKET_DETAILS_REQUEST,
  GET_TICKET_DETAILS_SUCCESS,
  GET_TICKET_DETAILS_FAILURE,
} from "./ticketsTypes";

const initialState = {
  loading: false,
  tickets: {},
  error: "",
};

const reportedTicketsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REPORTED_TICKETS_SUCCESS:
      return {
        loading: false,
        tickets: action.payload,
        error: "",
      };
    case GET_REPORTED_TICKETS_FAILURE:
      return {
        loading: false,
        tickets: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCreateIssue = {
  loading: false,
  issue: {},
  error: "",
};

const createIssueReducer = (state = initialStateForCreateIssue, action) => {
  switch (action.type) {
    case CREATE_REPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_REPORT_TICKET_SUCCESS:
      return {
        loading: true,
        issue: action.payload,
        error: "",
      };
    case CREATE_REPORT_TICKET_FAILURE:
      return {
        loading: false,
        issue: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateAddAttachments = {
  loading: false,
  attachments: {},
  error: "",
};

const addAttachmentsReducer = (state = initialStateAddAttachments, action) => {
  switch (action.type) {
    case ADD_ATTACHMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_ATTACHMENTS_SUCCESS:
      return {
        loading: false,
        attachments: action.payload,
        error: "",
      };
    case ADD_ATTACHMENTS_FAILURE:
      return {
        loading: false,
        attachments: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSupportHomePage = {
  loading: false,
  supportHomePage: {},
  error: "",
};

const supportHomePageReducer = (
  state = initialStateForSupportHomePage,
  action
) => {
  switch (action.type) {
    case TICKET_HOMEPAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TICKET_HOMEPAGE_SUCCESS:
      return {
        loading: true,
        supportHomePage: action.payload,
        error: "",
      };
    case TICKET_HOMEPAGE_FAILURE:
      return {
        loading: false,
        supportHomePage: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForRequestTypes = {
  loading: false,
  requestTypes: [],
  error: "",
};

const requestTypesReducer = (state = initialStateForRequestTypes, action) => {
  switch (action.type) {
    case GET_REQUESTTYPES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_REQUESTTYPES_SUCCESS:
      return {
        loading: false,
        requestTypes: action.payload,
        error: "",
      };
    case GET_REQUESTTYPES_FAILURE:
      return {
        loading: false,
        requestTypes: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForIssueStatus = {
  loading: false,
  issueStatus: {},
  error: "",
};

const issueStatusReducer = (state = initialStateForIssueStatus, action) => {
  switch (action.type) {
    case GET_TICKET_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKET_STATUS_SUCCESS:
      return {
        loading: false,
        issueStatus: action.payload,
        error: "",
      };
    case GET_TICKET_STATUS_FAILURE:
      return {
        loading: false,
        issueStatus: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCompletedTickets = {
  loading: false,
  compTickets: [],
  error: "",
};

const getCompletedTicketsReducer = (
  state = initialStateForCompletedTickets,
  action
) => {
  switch (action.type) {
    case GET_COMPLETED_TICKETS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPLETED_TICKETS_SUCCESS:
      return {
        loading: false,
        compTickets: action.payload,
        error: "",
      };
    case GET_COMPLETED_TICKETS_FAILURE:
      return {
        loading: false,
        compTickets: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForIssueComments = {
  loading: false,
  issueComments: [],
  error: "",
};

const issueCommentsReducer = (state = initialStateForIssueComments, action) => {
  switch (action.type) {
    case GET_TICKET_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKET_COMMENTS_SUCCESS:
      return {
        loading: false,
        issueComments: action.payload,
        error: "",
      };
    case GET_TICKET_COMMENTS_FAILURE:
      return {
        loading: false,
        issueComments: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForAddComment = {
  loading: false,
  issueComment: {},
  error: "",
};

const addIssueCommentReducer = (state = initialStateForAddComment, action) => {
  switch (action.type) {
    case ADD_TICKET_COMMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_TICKET_COMMENTS_SUCCESS:
      return {
        loading: false,
        issueComment: action.payload,
        error: "",
      };
    case ADD_TICKET_COMMENTS_FAILURE:
      return {
        loading: false,
        issueComment: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForReopenIssue = {
  loading: false,
  issue: {},
  error: "",
};

const reopenIssueReducer = (state = initialStateForReopenIssue, action) => {
  switch (action.type) {
    case RE_OPEN_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RE_OPEN_TICKET_SUCCESS:
      return {
        loading: false,
        issue: action.payload,
        error: "",
      };
    case RE_OPEN_TICKET_FAILURE:
      return {
        loading: false,
        issue: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForStatus = {
  loading: false,
  tickets: [],
  error: "",
};

const getTicketsByStatusForCompletedReducer = (
  state = initialStateForStatus,
  action
) => {
  switch (action.type) {
    case GET_TICKETS_COUNTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKETS_COUNTS_SUCCESS:
      return {
        loading: false,
        tickets: action.payload,
        error: "",
      };
    case GET_TICKETS_COUNTS_FAILURE:
      return {
        loading: false,
        tickets: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForActive = {
  loading: false,
  activeTickets: [],
  error: "",
};

const getTicketsForActiveReducer = (state = initialStateForActive, action) => {
  switch (action.type) {
    case GET_TICKETS_COUNTS_FOR_ACTIVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKETS_COUNTS_FOR_ACTIVE_SUCCESS:
      return {
        loading: false,
        activeTickets: action.payload,
        error: "",
      };
    case GET_TICKETS_COUNTS_FOR_ACTIVE_FAILURE:
      return {
        loading: false,
        activeTickets: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateForUser = {
  loading: false,
  homeTickets: [],
  error: "",
};

const homeTicketDetailsReducer = (state = initialStateForUser, action) => {
  switch (action.type) {
    case GET_TICKET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKET_DETAILS_SUCCESS:
      return {
        loading: false,
        homeTickets: action.payload,
        error: "",
      };
    case GET_TICKET_DETAILS_FAILURE:
      return {
        loading: false,
        homeTickets: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  reportedTicketsReducer,
  createIssueReducer,
  requestTypesReducer,
  supportHomePageReducer,
  issueStatusReducer,
  issueCommentsReducer,
  addIssueCommentReducer,
  reopenIssueReducer,
  addAttachmentsReducer,
  getCompletedTicketsReducer,
  getTicketsByStatusForCompletedReducer,
  getTicketsForActiveReducer,
  homeTicketDetailsReducer,
};
